import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { SHARED_MODULES } from '../../../../shared.';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type LayoutParamsDtypeElement = {
	faces_qty: number;
	placement_depth: number;
	placement_height: number;
};

@Component({
    selector: 'app-layout-params-dtype',
    templateUrl: 'layout-params-dtype.component.html',
	imports: [SHARED_MODULES],
    standalone: true
})
export class LayoutParamsDtypeComponent implements OnInit {

	element: Array<LayoutParamsDtypeElement>;
	text: string = '';

	constructor(@Inject(ELEMENT) private elementInjected: IInjectedElementDtype<{ data: Array<LayoutParamsDtypeElement> }>) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element.data;
		this.text = this.element
			.map((params: LayoutParamsDtypeElement) => {
				return params.faces_qty + ' - ' + params.placement_depth + ' - ' + params.placement_height;
			})
			.join('; ');
	}
}
